import { HttpMethods, APIContexts } from 'enums';
import { apiRequestHandler, apiHost } from '.';

const apiContext = `${APIContexts.BUSINESS_RULE}/`;

export const GetBusinessRuleDefinitionsAPI = ({ onSuccess, ...rest }) => {
  const endpoint = `${apiHost}${apiContext}definition`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};

export const AddBusinessRuleDefinitionAPI = ({
  requestBody,
  onSuccess,
  ...rest
}) => {
  const endpoint = `${apiHost}${apiContext}definition`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    payload: requestBody,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};

export const EditBusinessRuleDefinitionAPI = ({
  id,
  requestBody,
  onSuccess,
  ...rest
}) => {
  const endpoint = `${apiHost}${apiContext}definition/${id}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.PUT,
    payload: requestBody,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};

export const DeleteBusinessRuleDefinitionAPI = ({ id, onSuccess, ...rest }) => {
  const endpoint = `${apiHost}${apiContext}definition/${id}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.DELETE,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};

export const GetBusinessRuleValuesAPI = ({
  level,
  organisationId,
  onSuccess,
  ...rest
}) => {
  const params = new URLSearchParams();
  if (level !== null && level !== undefined) params.set('level', level);
  if (organisationId !== null && organisationId !== undefined) {
    params.set('organisationId', organisationId);
  }
  const query = params.toString() ? `?${params.toString()}` : '';
  const endpoint = `${apiHost}${apiContext}value${query}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};

export const AddBusinessRuleValueAPI = ({
  requestBody,
  onSuccess,
  ...rest
}) => {
  const endpoint = `${apiHost}${apiContext}value`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    payload: requestBody,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};

export const EditBusinessRuleValueAPI = ({
  id,
  requestBody,
  onSuccess,
  ...rest
}) => {
  const endpoint = `${apiHost}${apiContext}value/${id}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.PUT,
    payload: requestBody,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};

export const DeleteBusinessRuleValueAPI = ({ id, onSuccess, ...rest }) => {
  const endpoint = `${apiHost}${apiContext}value/${id}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.DELETE,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};

export const EditBusinessRuleChannelAPI = ({
  id,
  channelId,
  requestBody,
  onSuccess,
  ...rest
}) => {
  const endpoint = `${apiHost}${apiContext}channel/${id}?channelId=${channelId}`;

  apiRequestHandler({
    endpoint,
    method: HttpMethods.PUT,
    payload: requestBody,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};
